export const formatMeasurementValue = (value: number, unit: string = "") =>
  value ? `${value.toFixed(1)}${unit}` : "-";
